<template>
  <b-modal
    id="memberEmailModal"
    modal-class="client-details-modal"
    centered
    size="lg"
    hide-header-close
    hide-footer
  >
    <template #modal-header>
      <div class="view-clients-header">
        <b-button variant="close-btn" class="btn-container" @click="closeModal">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <b-container fluid>
      <div class="view-clients-modal-content">
        <h6>Send Message</h6>
        <div class="addMessage-form">
          <div class="radio-wrap">
            <label class="">
              <input
                type="radio"
                value="email&sms"
                v-model="selectedOption"
                class="ml-0"
              />
              Via Both (Email and SMS)
            </label>
            <label class="">
              <input type="radio" value="email" v-model="selectedOption" />
              Via Email
            </label>
            <label>
              <input type="radio" value="sms" v-model="selectedOption" />
              Via SMS
            </label>
          </div>

          <!-- Both Email and SMS Section -->
          <div v-if="selectedOption === 'email&sms'" class="content-box-wrap">
            <p class="send-via mt-3">Send via both Email and SMS</p>
            <div class="row memberSearch-wrap">
              <div class="col-md-6">
                <input-text
                  labelFor="member_email"
                  labelName="To:"
                  inputName="email"
                  :vmodel.sync="member.user_email"
                  readonly
                  formGroupClass="col-xxl-6 mb-3 w-100"
                />
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="control-label mb-2">CC:</label>
                  <input
                    v-model="form.ccAddress"
                    type="text"
                    class="form-control ml-0"
                    placeholder="Enter email address"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="control-label mb-2">BCC:</label>
                  <input
                    v-model="form.bccAddress"
                    type="text"
                    class="form-control ml-0"
                    placeholder="Enter email address "
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="control-label mb-2">Phone Number:</label>
                  <input
                    type="text"
                    class="form-control ml-0"
                    v-model="member.phone"
                    required
                    readonly
                    placeholder="Enter phone number"
                  />
                </div>
              </div>

              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <form
                  @submit.stop.prevent="handleSubmit(sendEmailAndSMS)"
                  ref="sendEmailContainer"
                >
                  <div class="form-group row">
                    <input-text
                      :rules="{ required: true }"
                      labelFor="subject"
                      labelName="Subject"
                      inputName="subject"
                      :vmodel.sync="form.subject"
                      formGroupClass="col-xxl-12 mb-3"
                    />

                    <div class="col-xxl-12 mb-3">
                      <validation-provider
                        name="Message"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <label for="" class="mb-2"
                          >Message <span class="required-indc">*</span></label
                        >
                        <textarea
                          class="form-control ml-0"
                          placeholder="Enter message"
                          v-model="form.both_message"
                          :rows="5"
                          :maxlength="250"
                          required
                        ></textarea>
                        <div class="remaining-characters mt-2">
                          <b>{{ 250 - form.both_message.length }}</b> characters remaining
                        </div>
                        <div class="invalid-block invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="col-xxl-12 mb-3 modal-inner-bg">
                    <label for="">From:</label>
                    <p>
                      <strong> {{ rep.display_name }}</strong>
                    </p>
                    <p v-if="rep.code">{{ rep.code }}</p>
                    <p>{{ rep.display_email }}</p>
                    <p>{{ rep.display_phone }}</p>
                  </div>

                  <div class="send-msg-footer">
                    <button type="button" class="btn cancel-btn btn-secondary" @click="closeModal">Cancel</button>
                    <b-button
                        class="univ-btn sendBtn mb-0 mt-0"
                        type="submit"
                        :disabled="isSend"
                      >
                        <template v-if="isSend"> Sending ... </template>
                        <template v-else> Send </template>
                      </b-button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>

          <!-- Email Section -->
          <div v-if="selectedOption === 'email'" class="content-box-wrap">
            <p class="send-via mt-3">Send via Email</p>
            <div class="row memberSearch-wrap">
              <div class="col-md-12">
                <input-text
                  labelFor="member_email"
                  labelName="To:"
                  inputName="email"
                  :vmodel.sync="member.user_email"
                  readonly
                  formGroupClass="col-xxl-6 mb-3 w-100"
                />
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="control-label mb-2">CC:</label>
                  <input
                    type="text"
                    v-model="form.ccAddress"
                    class="form-control ml-0"
                    placeholder="Enter email address "
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="control-label mb-2">BCC:</label>
                  <input
                    type="text"
                    v-model="form.bccAddress"
                    class="form-control ml-0"
                    placeholder="Enter email address "
                  />
                </div>
              </div>

              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <form
                  @submit.stop.prevent="handleSubmit(sendEmail)"
                  ref="sendEmailContainer"
                >
                  <div class="form-group row">
                    <input-text
                      :rules="{ required: true }"
                      labelFor="subject"
                      labelName="Subject"
                      inputName="subject"
                      :vmodel.sync="form.subject"
                      formGroupClass="col-xxl-12 mb-3"
                    />

                    <div class="col-xxl-12 mb-3">
                      <validation-provider
                        name="Message"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <label for="" class="mb-2"
                          >Message: <span class="required-indc">*</span></label
                        >
                        <ckeditor
                          :editor="editor"
                          v-model="form.message"
                          :config="editorConfig"
                        />
                        <div class="invalid-block invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="col-xxl-12 mb-3 modal-inner-bg">
                    <label for="">From:</label>
                    <p>
                      <strong> {{ rep.display_name }}</strong>
                    </p>
                    <p v-if="rep.code">{{ rep.code }}</p>
                    <p>{{ rep.display_email }}</p>
                    <p>{{ rep.display_phone }}</p>
                  </div>
                  <div class="send-msg-footer">
                    <button type="button" class="btn cancel-btn btn-secondary" @click="closeModal">Cancel</button>
                    <b-button
                        class="univ-btn sendBtn mb-0 mt-0"
                        type="submit"
                        :disabled="isSend"
                      >
                        <template v-if="isSend"> Sending ... </template>
                        <template v-else> Send </template>
                      </b-button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>

          <!-- SMS Section -->
          <div v-if="selectedOption === 'sms'" class="content-box-wrap">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form
                @submit.stop.prevent="handleSubmit(sendSMS)"
                ref="sendSmsContainer"
              >
            <p class="send-via mt-3">Send via SMS</p>
            <div class="memberSearch-wrap">
              <div class="form-group mb-3">
                <label class="control-label mb-2">Phone Number:</label>
                <input
                  type="text"
                  class="form-control ml-0"
                  placeholder="Enter phone number"
                  v-model="member.phone"
                  readonly
                  required
                />
              </div>
              <div class="form-group mb-3">
                <div class="col-xxl-12 mb-3">
                  <validation-provider
                    name="Message"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="" class="mb-2"
                      >Message: <span class="required-indc">*</span></label
                    >
                    <!-- only 250 characters allowed, display remaining characters -->
                    <textarea
                      class="form-control ml-0"
                      placeholder="Enter message"
                      v-model="form.both_message"
                      :rows="5"
                      :maxlength="250"
                      required
                    ></textarea>
                    <div class="remaining-characters">
                      {{ 250 - form.both_message.length }} characters remaining
                    </div>

                    <div class="invalid-block invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>

            <div class="send-msg-footer">
              <button type="button" class="btn cancel-btn btn-secondary" @click="closeModal">Cancel</button>
              <b-button
                  class="univ-btn sendBtn mb-0 mt-0"
                  type="submit"
                  :disabled="isSend"
                >
                  <template v-if="isSend"> Sending ... </template>
                  <template v-else> Send </template>
                </b-button>
            </div>
            </form>
            </ValidationObserver>
          </div>

        </div>
      </div>
    </b-container>
  </b-modal>
</template>
<script>

import { mapGetters } from "vuex";
import Helper from "@/resource/Helper";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";

export default {
  name: "MemberEmailModal",
  data: () => ({
    editor: ClassicEditor,
    editorConfig: Helper.simpleEditorConfig(),
    form: {
      user_id: "",
      subject: "",
      message: "",
      both_message: "",
      bccAddress: "",
      ccAddress: "",
    },
    isSend: false,
    selectedOption: "email&sms",
  }),
  props: {
    member: {
      required: true,
    },
  },
  computed: {
    ...mapGetters({ rep: "rep" }),
  },
  methods: {
    reset() {
      this.form = {
        user_id: "",
        subject: "",
        message: "",
        both_message: "",
        bccAddress: "",
        ccAddress: "",
      };
    },
    closeModal() {
      this.$bvModal.hide("memberEmailModal");
      this.$emit("onClosedModal");
      this.reset();
    },
    sendEmail({ skipResetClose = false } = {}) {
    this.isSend = true;
      const url = this.$endpoint.MSG_API_URL+`api/v1/send-email-with-content-data`;
      this.form.user_id = this.member.user_id;
      let loader = this.$loading.show({
        container: this.$refs.sendEmailContainer,
      });

      let data ={
        toAddress: [this.member.user_email],
        subject: this.form.subject,
        contentData: {
          content: this.selectedOption === "email&sms" ? this.form.both_message : this.form.message
        },
        email_message_configuration_name: this.$endpoint.GENERIC_EMAIL_CONFIG,
        ccAddress: this.form.ccAddress ? this.form.ccAddress.split(",").map(email => email.trim()) : [],
        bccAddress: this.form.bccAddress ? this.form.bccAddress.split(",").map(email => email.trim()) : []
      }

      return axios.post(url, data,{
        headers:{
         'X-Msgcenter-Token': Helper.messagingApiToken()
        }
      }).then(({ data }) => {
        if (data.status === "success" || data.status_code == "200") {
          this.$notify('Email sent successfully!');
          if (!skipResetClose) {
            this.reset();
            this.closeModal();
          }
          return true;
        } else {
          this.$notify(data.message || 'Failed to send email. Please try again.', 'error');
          throw new Error(data.message || 'Failed to send email.');
        }
      }).catch((err) => {
        console.log(err)
        this.$notify('Failed to send email. Please try again.', 'error');
        throw new Error('Failed to send email.');
      }).finally(() => {
        this.isSend = false;
        loader.hide();
      });
    },
    sendSMS({ skipResetClose = false } = {}) {
      this.isSend = true;
      let url = this.$endpoint.MSG_API_URL + 'api/v1/send-sms-with-content';
      let {
        both_message: body
      } = this.form;
      return axios.post(url, {
        phone: this.member.phone,
        body
      },{
        headers:{
         'X-Msgcenter-Token': Helper.messagingApiToken()
        }
      }).then(({ data }) => {
        if (data.status === "success" || data.status_code == "200") {
          this.$notify('SMS sent successfully!');
          if (!skipResetClose) {
            this.reset();
            this.closeModal();
          }
          return true;
        } else {
          this.$notify(data.message || 'Failed to send SMS. Please try again.', 'error');
          throw new Error(data.message || 'Failed to send SMS.');
        }
      }).catch((err) => {
        console.log(err)
        this.$notify('Failed to send SMS. Please try again.', 'error');
        throw new Error('Failed to send SMS.');
      }).finally(() => {
        this.isSend = false;
      });
    },

    async sendEmailAndSMS() {
      this.isSend = true;
      try {
        await this.sendEmail({ skipResetClose: true });
        await this.sendSMS({ skipResetClose: true });
        // Only if both succeed:
        this.reset();
        this.closeModal();
      } catch (err) {
        console.log(err);
        this.$notify('Something went wrong. Please try again.', 'error');
        // Do NOT close/reset here
      } finally {
        this.isSend = false;
      }
    }
  },
};
</script>
<style >
.ck-content {
  height: 200px;
}
.radio-wrap {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}
.radio-wrap input {
  width: auto !important;
  position: relative;
  top: 2.2px;
}
.send-via {
  font-weight: 500;
  font-size: 15px;
  color: #2c3f58;
  border-bottom: 1px solid #ccc;
  max-width: fit-content;
  padding-bottom: 0.3rem;
}
.cancel-btn {
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  text-align: center;
  padding: 10px 70px;
  transition: all ease 0.6s;
  margin-right: 0.8rem;
}

#memberEmailModal .modal-header {
  padding: 0;
}

.send-msg-footer{
  display: flex;
  justify-content: end;
  align-items: center;
  position: sticky;
  background: #fff;
  padding: 0.8rem 0 0.8rem 0;
  bottom: 0;
  z-index: 9;
}
.send-msg-footer button{
    width: 100%;
    max-width: 178px !important;
  }
#memberEmailModal .modal-content .modal-body{
  padding-bottom: 0;
}
@media (max-width: 1400px){

  .send-msg-footer button.univ-btn{
    font-size: 16px;
  }
}
@media (max-width: 485px) {
  .send-msg-footer{
    flex-direction: column-reverse;
  }
  .send-msg-footer button{
    max-width: 100% !important;
    margin: 0;
    width: 100%;
  }
  .send-msg-footer button.univ-btn{
    margin-bottom: 10px !important;
  }
}
</style>